export var addressValidationFields = [{
  field: 'firstName',
  method: 'isEmpty',
  validWhen: false,
  message: 'Error: Please fill in your first name'
}, {
  field: 'firstName',
  method: 'matches',
  args: [/^[a-zA-Z ]{1,17}$/],
  validWhen: true,
  message: 'Error: Please enter a valid name, avoid numbers and special characters'
}, {
  field: 'lastName',
  method: 'isEmpty',
  validWhen: false,
  message: 'Error: Please fill in your last name'
}, {
  field: 'lastName',
  method: 'matches',
  args: [/^[a-zA-Z ]{1,17}$/],
  validWhen: true,
  message: 'Error: Please enter a valid name, avoid numbers and special characters'
}, {
  field: 'addressLine1',
  method: 'isEmpty',
  validWhen: false,
  message: 'Error: Please enter a valid street address'
}, {
  field: 'city',
  method: 'isEmpty',
  validWhen: false,
  message: 'Error: Please enter a valid city'
}, {
  field: 'city',
  method: 'matches',
  args: [/^[a-zA-Z ]{2,30}$/],
  validWhen: true,
  message: 'Error: Please enter a valid city, avoid numbers and special characters'
}, {
  field: 'country',
  method: 'matches',
  args: [/^[a-zA-Z ]{2,30}$/],
  validWhen: true,
  message: 'Error: Please enter a valid name, avoid numbers and special characters'
}, {
  field: 'country',
  method: 'matches',
  args: [/^[a-zA-Z ]{2,30}$/],
  validWhen: true,
  message: 'Error: Please enter a valid name, avoid numbers and special characters'
}, {
  field: 'phoneNumber',
  method: 'isEmpty',
  validWhen: false,
  message: 'Error: Please fill in your phone number'
}, {
  field: 'phoneNumber',
  method: 'matches',
  args: [/^\(?\d\d\d\)?[,-] ?\d\d\d-?[,-]\d\d\d\d$/],
  validWhen: true,
  message: 'Error: Phone number should contain only 10 numbers'
}, {
  field: 'postalCode',
  method: 'isEmpty',
  validWhen: false,
  message: 'Error: Please enter a valid zip code'
}, {
  field: 'postalCode',
  method: 'matches',
  args: [/^\(?\d\d\d\d/],
  validWhen: true,
  message: 'Error: Please enter a valid zip code'
}];